import styles from './stylesSortingTable.module.css';

import LeagueRow from '../LeagueRow/LeagueRow';

const SortingTable = ({
  columns,
  leagues,
  setLeagues,
  toggleStatus,
  togglePin,
  etype,
  sportId,
}) => {
  return (
    <table className={styles.sortingTable}>
      <thead>
        <tr className={styles.headerRow}>
          {columns.map((column, index) => {
            return (
              <th className={styles.headerCell} key={index}>
                <div className={styles.headerCellContent}>
                  <span>{column}</span>
                </div>
              </th>
            );
          })}
          <th className={styles.headerCell}>
            <div className={styles.headerCellContent}></div>
          </th>
        </tr>
      </thead>
      <tbody>
        {leagues.map((league, index) => (
          <LeagueRow
            key={league.league_id}
            league={league}
            order={index + 1}
            toggleStatus={toggleStatus}
            togglePin={togglePin}
            etype={etype}
            setLeague={setLeagues}
            columns={columns}
            sportId={sportId}
          />
        ))}
      </tbody>
    </table>
  );
};

export default SortingTable;
